import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import {
  MetadataPopoverComponent,
  ReportDataTableComponent,
  ReportRunBannerComponent,
  UserAccessAvatarComponent,
} from '@mode/report-viewer/ui';

export const DowngradedReportViewerUIModule = angular
  .module('downgraded-report-viewer-ui', [])
  .directive('modeReportDataTable', downgradeComponent({ component: ReportDataTableComponent }))
  .directive('userAccessAvatar', downgradeComponent({ component: UserAccessAvatarComponent }))
  .directive('modeMetadataPopover', downgradeComponent({ component: MetadataPopoverComponent }))
  .directive('modeReportRunBanner', downgradeComponent({ component: ReportRunBannerComponent })).name;
